module.exports = {
  View2D: 1,
  View3D: 2
};
